(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["indithrob-welcome"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.querySelector('[data-ith-welcome]');
  if (!dialog || !dialog.showModal) return;
  const key = 'ith_welcome15_seen';
  try { if (Date.now() - Number(localStorage.getItem(key)) < 604800000) return; } catch {}
  const timer = setTimeout(() => {
    if (document.querySelector('dialog[open]') || document.hidden) return;
    dialog.showModal();
    try { localStorage.setItem(key, String(Date.now())); } catch {}
  }, 15000);
  window.addEventListener('pagehide', () => clearTimeout(timer), {once:true});
})();
  } catch(e) { console.error(e); }
})();

})();
